import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Grid, Typography, Divider, Switch, TextField, Button, LinearProgress } from '@material-ui/core';
import { Breadcrumb } from 'components';
import { getStoreConfigsApi, updateStoreConfigsApi } from 'api';
import { changeStoreConfig } from 'redux/actions/store_configs';


export default function Recaptcha() {
  const dispatch = useDispatch();

  const {storeConfigs, loading, error} = useSelector((state) => state.store_configs);

  useEffect(() => {
    if (storeConfigs.length === 0) {
      getStoreConfigsApi({dispatch});
    }
  }, []);

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeStoreConfig(name, checked, type, value));
  };

  const handleSave = () => {
    const configs = [];

    storeConfigs.forEach((config) => {
      if (['customer/recaptcha/enabled'].includes(config.path)) {
        configs.push(config);

        if (config.value) {
          configs.push({path: 'customer/recaptcha/forms', value: 'customer_account_create,contact_index_index,skinquiz_quiz_index,customer_account_forgotpassword'});
        }
      }

      if (['customer/recaptcha/site_key', 'customer/recaptcha/secret_key'].includes(config.path)) {
        configs.push({ ...config, encrypt: 1 });
      }
    });

    updateStoreConfigsApi({dispatch, configs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          isCapitalize={Boolean(false)}
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Go Live Requirements', path: '/settings#go_live_requirements' },
            { name: 'reCAPTCHA' }
          ]}
        />
      </div>
      <div className="m-10">
        <Card className="p-8">
          {loading && <LinearProgress className="mt-10 mx-10" />}
          {!loading && error && <div className="m-10">Can&apos;t fetch Shipping data</div>}
          {!loading && storeConfigs.length !== 0 &&
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <p className="text-gray">In this section you can allow or disallow reCAPTCHAS in your store</p>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">reCAPTCHA</Typography>
              </Grid>
              <Grid item xs={12} sm={3} md={3}>
                Enable reCAPTCHA:
              </Grid>
              <Grid item xs={12} sm={9} md={9}>
                <Switch
                  color="primary"
                  name="customer/recaptcha/enabled"
                  value="skinquiz_quiz_index"
                  checked={storeConfigs.find((config) => config.path === 'customer/recaptcha/enabled')?.value == 1}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={3}>
                Site Key:
              </Grid>
              <Grid item xs={12} sm={9} md={9}>
                <TextField
                  fullWidth
                  className="max-w-600"
                  variant="outlined"
                  name="customer/recaptcha/site_key"
                  value={storeConfigs.find((config) => config.path === 'customer/recaptcha/site_key')?.value}
                  label="Site Key"
                  onChange={(event) => {
                    handleChange(event);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={3}>
                Secret Key:
              </Grid>
              <Grid item xs={12} sm={9} md={9}>
                <TextField
                  fullWidth
                  className="max-w-600"
                  variant="outlined"
                  name="customer/recaptcha/secret_key"
                  value={storeConfigs.find((config) => config.path === 'customer/recaptcha/secret_key')?.value}
                  label="Secret Key"
                  onChange={(event) => {
                    handleChange(event);
                  }}
                />
              </Grid>
            </Grid>
            <div className="flex justify-end mt-4">
              <Button variant="contained" color="primary" className="my-10" onClick={handleSave}>Save Configurations</Button>
            </div>
          </>
          }
        </Card>
      </div>
    </div>
  );
}
